<div fxLayout="column" fxLayoutGap="5px">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <span style="width:24px;"></span>
    <div class="quickLink">
      <ng-container *ngFor="let quickFilter of quickFilters">
        <ng-container *ngFor="let quick of quickFilter.quicks">
          <span  (click)="onQuickFilter(quickFilter, quick)" translate>{{quick.title}}</span>
        </ng-container>
      </ng-container>
    </div>

  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">

    <mat-icon>filter_list</mat-icon>

    <mat-chip-listbox aria-label="Filter selection">
      <ng-container *ngFor="let filter of filters">
        <mat-chip-option *ngIf="filter.selected" color="accent" selected (click)="filterSelected(filter)" >
          {{filter.selected.display}}
          <mat-icon matChipTrailingIcon (click)="removeFilter(filter)">close</mat-icon>
        </mat-chip-option>
      </ng-container>

      <mat-chip-option [matMenuTriggerFor]="menu">
        <mat-icon matChipAvatar>add</mat-icon>
        <span translate>A2FILTER.NEW</span>
      </mat-chip-option>
    </mat-chip-listbox>

  </div>
</div>




<mat-menu #menu="matMenu">
  <button  *ngFor="let filter of filters" mat-menu-item (click)="filterSelected(filter)" translate>{{filter.name}}</button>
</mat-menu>
